import { Controller } from "@hotwired/stimulus";

export default class extends Controller {
  static targets = ["table"];

  connect() {
    document.addEventListener("turbo:before-fetch-request", this.show);
    document.addEventListener("turbo:load", this.hide);
    document.addEventListener("turbo:render", this.hide);
  }

  disconnect() {
    document.removeEventListener("turbo:before-fetch-request", this.show);
    document.removeEventListener("turbo:load", this.hide);
    document.removeEventListener("turbo:render", this.hide);
  }

  show = (event) => {
    if (!this.hasTableTarget) return;
    const source = event.detail?.fetchOptions?.headers?.["Turbo-Frame"];
    if (source && this.element.contains(document.getElementById(source))) {
      this.tableTargets.forEach((table) => table.classList.add("skeleton-loading"));
    }
  };

  hide = () => {
    this.tableTargets.forEach((table) => table.classList.remove("skeleton-loading"));
  };
}
